import Calendar from 'vue-calendar-component'
const component = {
  install: function(Vue) {
    Vue.component('my-calendar', Calendar)
  }
}
export default component
